<template>
    <main class="container__sitevitrine_desktop" id="sitevitrine_desktop">
        <!--  section left-->
        <secction class="container__sitevitrine_desktop__section_left">
            <article class="container__sitevitrine_desktop__section_left__article">
                <!-- aside top -->
                <aside class="container__sitevitrine_desktop__section_left__article__aside_top">
                    <div class="container__sitevitrine_desktop__section_left__article__aside_top__div">
                        <img src="@/assets/screen-3001951.png" alt="Site vitrine"
                            class="container__sitevitrine_desktop__section_left__article__aside_top__div__img">
                    </div>
                </aside>
                <!-- aside bottom-->
                <aside class="container__sitevitrine_desktop__section_left__article__aside_bottom">
                    <div class="container__sitevitrine_desktop__section_left__article__aside_bottom__div_text">
                        <p class="container__sitevitrine_desktop__section_left__article__aside_bottom__div_text__p">
                            Un site vitrine est un site Web qui présente en ligne les produits ou les services d'une
                            organisation, dans le but d'attirer simplement l'attention et d'éveiller l'intérêt des
                            internautes de passage, le plus souvent sans permettre d'acheter directement le produit ou
                            le service proposé.
                        </p>
                    </div>
                    <div class="container__sitevitrine_desktop__section_left__article__aside_bottom__div_link">
                        <a href="https://fr.wikipedia.org/wiki/Site_vitrine"
                            class="container__sitevitrine_desktop__section_left__article__aside_bottom__div_link__a">
                            <p class="container__sitevitrine_desktop__section_left__article__aside_bottom__div_link__a__p">
                                wikipédia
                            </p>
                        </a>
                    </div>
                </aside>
            </article>
        </secction>
        <!-- ############## -->
        <!-- section middle -->
        <!-- ############## -->
        <secction class="container__sitevitrine_desktop__section_middle">
            <!-- article top -->
            <article class="container__sitevitrine_desktop__section_middle__article_top">
                <aside class="container__sitevitrine_desktop__section_middle__article_top__aside">
                    <!-- div vide -->
                    <div class="container__sitevitrine_desktop__section_middle__article_top__aside__div_vide_1">

                    </div>

                    <!-- div titre -->
                    <div class="container__sitevitrine_desktop__section_middle__article_top__aside__div_titre">
                        <h1 class="container__sitevitrine_desktop__section_middle__article_top__aside__div_titre__h1">
                            Site vitrine
                        </h1>
                    </div>

                    <!-- div vide -->
                    <div class="container__sitevitrine_desktop__section_middle__article_top__aside__div_vide_2">

                    </div>

                </aside>
            </article>
            <!-- ############## -->
            <!-- Article middle -->
            <!-- ############## -->
            <article class="container__sitevitrine_desktop__section_middle__article_middle w3-container__sitevitrine_desktop">
                <aside id="id01" class="container__sitevitrine_desktop__section_middle__article_middle__aside w3-modal ">
                    <!-- div options -->
                    <div class="w3-modal-content container__sitevitrine_desktop__section_middle__article_middle__aside__div_option">
                        <div class="w3-container__sitevitrine_desktop container__sitevitrine_desktop__section_middle__article_middle__aside__div_option__div">
                            <span onclick="document.getElementById('id01').style.display='none'"
                                class="w3-button w3-display-topright container__sitevitrine_desktop__section_middle__article_middle__aside__div_option__div__span">&times;</span>
                            <h1 class="container__sitevitrine_desktop__section_middle__article_middle__aside__div_option__div__h1">
                                Options
                            </h1>
                            <p class="container__sitevitrine_desktop__section_middle__article_middle__aside__div_option__div__p">
                                - 100€ maquette sans animation ( adobe XD ) <br>
                                - 300€ maquette avec animations <br>
                                - 100€ la modifications et 50€ par jours de retard ( du client au sujet de la
                                modifications
                                maquette )<br>
                                - 100€ l'hébergement web<br>
                                - 1 000€ déplacement ( en France )( voir CGV pour plus d'information )<br>
                                - Maintenance 140€ l'ajout<br>
                                - Devis 100€<br>
                            </p>
                        </div>
                    </div>
                </aside>
            </article>
            <!-- ############## -->
            <!-- Article bottom -->
            <!-- ############## -->
            <article class="container__sitevitrine_desktop__section_middle__article_bottom">
                <!-- précédent -->
                <aside class="container__sitevitrine_desktop__section_middle__article_bottom__aside_back">
                    <div class="container__sitevitrine_desktop__section_middle__article_bottom__aside_back__div">
                        <button class="container__sitevitrine_desktop__section_middle__article_bottom__aside_back__div__button">
                            <router-link
                                class="container__sitevitrine_desktop__section_middle__article_bottom__aside_back__div__button__router-link"
                                to="/wordpress">
                                <div
                                    class="container__sitevitrine_desktop__section_middle__article_bottom__aside_back__div__button__router-link__div_1">

                                </div>
                                <!--  -->
                                <div
                                    class="container__sitevitrine_desktop__section_middle__article_bottom__aside_back__div__button__router-link__div_2">

                                </div>
                            </router-link>
                        </button>
                    </div>
                </aside>
                <!-- suivant -->
                <aside class="container__sitevitrine_desktop__section_middle__article_bottom__aside_next">
                    <div class="container__sitevitrine_desktop__section_middle__article_bottom__aside_next__div">
                        <button class="container__sitevitrine_desktop__section_middle__article_bottom__aside_next__div__button">
                            <router-link
                                class="container__sitevitrine_desktop__section_middle__article_bottom__aside_next__div__button__router-link"
                                to="/application-web">
                                <div
                                    class="container__sitevitrine_desktop__section_middle__article_bottom__aside_next__div__button__router-link__div_1">

                                </div>
                                <!--  -->
                                <div
                                    class="container__sitevitrine_desktop__section_middle__article_bottom__aside_next__div__button__router-link__div_2">

                                </div>
                            </router-link>
                        </button>
                    </div>
                </aside>
            </article>
        </secction>
        <!-- ############## -->
        <!-- section right -->
        <!-- ############## -->
        <secction class="container__sitevitrine_desktop__section_right">
            <article class="container__sitevitrine_desktop__section_right__article">
                <aside class="container__sitevitrine_desktop__section_right__article__aside_top">
                    <div class="container__sitevitrine_desktop__section_right__article__aside_top__div">
                        <h1 class="container__sitevitrine_desktop__section_right__article__aside_top__div__h1">
                            Tarifs
                        </h1>
                    </div>
                </aside>
                <!--  -->
                <aside class="container__sitevitrine_desktop__section_right__article__aside_middle">
                    <!-- div text -->
                    <div class="container__sitevitrine_desktop__section_right__article__aside_middle__div_text">
                        <p class="container__sitevitrine_desktop__section_right__article__aside_middle__div_text__p_top">
                            - Maquette Adobe XD <br>
                            - 2 Modifications gratuites <br>
                            - Réalisation rapide <br>
                        </p>
                        <!-- prix -->
                        <p class="container__sitevitrine_desktop__section_right__article__aside_middle__div_text__p_bottom">
                            Prix total : 1 600 €
                        </p>
                    </div>
                </aside>
                <!-- aside bottom button -->
                <aside class="container__sitevitrine_desktop__section_right__article__aside_bottom">
                    <div class="container__sitevitrine_desktop__section_right__article__aside_bottom__div_left">
                        <router-link class="container__sitevitrine_desktop__section_right__article__aside_bottom__div_left__router-link"
                            to="/contact">
                            <p class="container__sitevitrine_desktop__section_right__article__aside_bottom__div_left__router-link__p">
                                Choisir
                            </p>
                        </router-link>
                    </div>
                    <!-- button -->
                    <div class="container__sitevitrine_desktop__section_right__article__aside_bottom__div_right">
                        <button onclick="document.getElementById('id01').style.display='block'"
                            class="container__sitevitrine_desktop__section_right__article__aside_bottom__div_right__button">
                            <div class="container__sitevitrine_desktop__section_right__article__aside_bottom__div_right__button__div_1">

                            </div>
                            <!--  -->
                            <div class="container__sitevitrine_desktop__section_right__article__aside_bottom__div_right__button__div_2">

                            </div>
                        </button>
                    </div>
                </aside>
            </article>
        </secction>
    </main>
</template>

<script >
export default {
    name: 'SiteVitrineDesktop',
}
</script>

<style  lang=scss>
@import "@/style/components/Services/Site-vitrine/SiteVitrineDesktop.scss";

router-link {
    display: block;
}

@import "@/style/color.scss";


@media screen and(max-width: 926px) {
    #sitevitrine_desktop {
        display: none;
    }
}
</style>